import axios from "axios"

export default class LanguageService {
    static #apiUrl = process.env.REACT_APP_MIFIRMA_API


    /**
     * @typedef Language
     * @prop {number} id
     * @prop {string} name
     * @prop {string} description
     * @prop {number} isoCode
     * @typedef {Object} languages
     * @property {string} consecutive
     * @property {Array<Language>} data
     * @property {number} statusCode
     * @property {string} message
    */

    /**
     * @author Pedro Antonio
     * @description Retrieve all languages active availables
     * @param {string} token 
     * @returns {languages} 
     * @memberof LanguageService
     */
    static async getLanguages(token) {
        return axios.get(`${this.#apiUrl}/languages`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        }).then(response => response.data)
    }
}